"use strict";

ubian = ubian || {};

ubian.orders = {};
/**
 * data of items and order to be cancelled
 * @type object
 */
ubian.orders.cancelData = {
    ids: [],
    order_id: null
};

/**
 * check whether items are marked for cancellation and show confirmation dialog before cancelling items
 * @returns {undefined}
 */
ubian.orders.cancelItems = function () {
    if (!$('.js-order-cancel-checkbox:checked').length) {
        ubian.utils.alert(ubian.translate('JS.Error.OrderCancel.SelectItems'));
        return;
    }
    // cancellation of ifc order
    if ($('.js-order-cancel').data('ifcid')) {
        window.location = ubian.routes['order_info_ifc'].replace('-ifcid-', $('.js-order-cancel').data('ifcid'));
        return;
    }
    var ids = [];
    $('.js-order-cancel-checkbox:checked').each(function () {
        if (ids.indexOf($(this).val()) === -1) {
            ids.push($(this).val());
        }
    });
        ubian.orders.cancelData = {ids: ids, order_id: $('.js-order-cancel').data('id')};
    ubian.utils.confirm(ubian.translate('JS.Orders.ConfirmItemsCancel'), '', 'OK', 'javascript:ubian.orders.performCancel();');

};
/**
 * cancel items and show result
 * @returns {undefined}
 */
ubian.orders.performCancel = function () {
    $.post(ubian.routes['order_cancel_items'], ubian.orders.cancelData, function (res) {
        if (typeof res.status !== 'undefined' && res.status === 'ok') {
            window.location = res.url;
        } else {
            ubian.utils.alert(ubian.translate('JS.Error.OrderCancel.Failed'));
        }
    });
};
/**
 * mark all related checkboxes (mobile/desktop view), update number of items, enable/disable button
 * @param {type} checkbox
 * @returns {undefined}
 */
ubian.orders.handleSelectionChange = function (checkbox) {
    var val = $(checkbox).val();
    if ($(checkbox).is(':checked')) {
        $('.js-order-cancel-checkbox[value=' + val + ']').not(checkbox).prop('checked', true);
    } else {
        $('.js-order-cancel-checkbox[value=' + val + ']').not(checkbox).prop('checked', false);
    }
    var cnt = $(checkbox).parents('table').find('.js-order-cancel-checkbox:checked').length;
    /*if (cnt) {
        $('.js-order-cancel').removeClass('btn-transparent-gray');
        $('.js-order-cancel').addClass('btn-red');
    } else {
        $('.js-order-cancel').addClass('btn-transparent-gray');
        $('.js-order-cancel').removeClass('btn-red');
    }*/
    $('.js-order-cancel span').text(cnt);

};
/**
 * bind event handlers
 * @returns {undefined}
 */
ubian.orders.init = function () {
    $('.js-order-list-info').click(function () {
        var template = $('#js-order-list-info-modal').html();
        $(template).modal();
    });
    // handle cancel checkboxes
    $('.js-order-cancel-checkbox').change(function () {
        ubian.orders.handleSelectionChange(this);
    });
    //
    $('.js-order-cancel').click(function () {
        ubian.orders.cancelItems();
    });
};


$(ubian.orders.init);